var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXbc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6121 11.1116L14.3055 12.3395L13.4871 12.1359L13.7931 10.9074L12.5651 10.6014L12.7693 9.78298L13.9972 10.089L14.3038 8.86104L15.1222 9.06523L14.8162 10.2932L16.0442 10.5992L15.84 11.4182L14.6121 11.1116ZM11.5931 7.73998C11.4789 8.49935 11.0649 8.86835 10.5176 8.99998C11.2663 9.39542 11.6454 10.0052 11.2759 11.0683C10.8169 12.3885 9.7425 12.5055 8.316 12.2383L7.96162 13.6569L7.12575 13.4488L7.47506 12.0482C7.25243 11.9931 7.03042 11.9355 6.80906 11.8755L6.45806 13.2817L5.62331 13.0736L5.97769 11.6516C5.78194 11.6015 5.58394 11.5487 5.38144 11.498L4.293 11.2264L4.71375 10.2465C4.71375 10.2465 5.32969 10.4102 5.32125 10.3984C5.55862 10.4563 5.66437 10.2982 5.70656 10.193L6.26569 7.94979L6.35456 7.97173C6.32617 7.9604 6.29704 7.951 6.26737 7.9436L6.66675 6.34217C6.678 6.16048 6.61781 5.9321 6.27862 5.84717C6.29212 5.83873 5.67169 5.69642 5.67169 5.69642L5.8995 4.78292L7.05262 5.07092L7.0515 5.07485C7.22475 5.11817 7.40362 5.15923 7.58587 5.20029L7.93631 3.79517L8.77219 4.00329L8.4285 5.38142C8.65294 5.43204 8.8785 5.48379 9.09787 5.53892L9.43931 4.17035L10.2757 4.37848L9.92531 5.78417C10.9806 6.14979 11.7506 6.70273 11.5931 7.73998ZM9.66544 10.4878C9.94162 9.37967 8.12306 9.10404 7.55606 8.96229L7.0875 10.845C7.6545 10.9856 9.40219 11.5498 9.66656 10.4872L9.66544 10.4878ZM9.93937 7.73379C10.1902 6.72523 8.66925 6.50923 8.19731 6.39167L7.7715 8.09998C8.24344 8.2181 9.69806 8.70017 9.93937 7.73379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXbc);
export default __webpack_public_path__ + "static/media/xbc.1349c4650d6b092c8de7a2f3a5e88a3b.svg";
export { ForwardRef as ReactComponent };